export const HTTP_ERROR_MAP: { [key: string]: string } = {
    'Network Error': 'Network Error ',
};
